import React, {useEffect, useState} from "react";
import "./SnippetEditor.scss";
import {default as axios} from "axios";
import ErrorMessage from "../misc/ErrorMessage";
import domain from "../../util/domain";

function SnippetEditor ({getSnippets, setNewSnippetEditorOpen, editSnippetData}) {
    const [editorPCP, setEditorPCP] = useState("");
    const [editorlastName, setEditorlastName] = useState("");
    const [editorfirstName, setEditorfirstName] = useState("");
    const [editorroomNumber, setEditorroomNumber] = useState("");
    const [errorMessage,setErrorMessage]  = useState(null);

    useEffect(() => {
        if (editSnippetData) {
            setEditorPCP(editSnippetData.PCP ? editSnippetData.PCP : "");
            setEditorlastName(editSnippetData.lastName ? editSnippetData.lastName : "");
            setEditorfirstName(editSnippetData.firstName ? editSnippetData.firstName : "");
            setEditorroomNumber(editSnippetData.roomNumber ? editSnippetData.roomNumber : "");

        }
    }, [editSnippetData]);

    function closeEditor() {
        setNewSnippetEditorOpen(false);
        setEditorPCP("");
        setEditorfirstName("");
        setEditorlastName("");
        setEditorroomNumber("");
    }

    async function saveSnippet(e) {
        e.preventDefault();
        const snippetData = {
            PCP: editorPCP ? editorPCP : undefined,
            lastName: editorlastName ? editorlastName : undefined,
            firstName: editorfirstName ? editorfirstName : undefined,
            roomNumber: editorroomNumber ? editorroomNumber : undefined,
        }
        try {
            if (!editSnippetData)
                await axios.post(domain + "/snippet/", snippetData);
            else {
                console.log(editSnippetData._id);
                await axios.put(domain + "/snippet/" + editSnippetData._id, snippetData);
            }
        }
        catch (err) {
            if (err.response) {
                if (err.response.data.errorMessage) {
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
            return;
        }

        getSnippets();
        closeEditor();
    }
    return (
        <div className="snippet-editor">
            {
                errorMessage && <ErrorMessage message={errorMessage}
                                              clear={() => setErrorMessage(null)} />
            }
        <form className="form" onSubmit={saveSnippet}>
            <label htmlFor="editor-title">PCP</label>
            <input id="editor-title" type={"text"} value={editorPCP} onChange={(e) =>
                setEditorPCP(e.target.value)}/>

            <label htmlFor="editor-firstName">First Name</label>
            <input id="editor-firstName" type={"text"} value={editorlastName} onChange={(e) =>
                setEditorlastName(e.target.value)}/>

            <label htmlFor="editor-lastName">Last Name</label>
            <input id="editor-lastName" type={"text"} value={editorfirstName} onChange={(e) =>
                setEditorfirstName(e.target.value)}/>

            <label htmlFor="editor-roomNumber">Room Number</label>
            <input id="editor-roomNumber" type={"number"} value={editorroomNumber} onChange={(e) =>
                setEditorroomNumber(e.target.value)}/>
            <button className="btn-save" type={"submit"}>Save</button>
            <button className="btn-cancel" type={"submit"} onClick={closeEditor}>Cancel</button>
        </form>
    </div>
);
}

export default SnippetEditor;